import { useHistory } from 'react-router-dom'
import { useCallback } from 'react'
import { History } from 'history'
import { ExtractRouteParams, Routes, urlWithParams } from '../routing'

type NavigationHooks = {
  readonly history: History
  readonly goBack: () => void
  readonly goTo: (url: Routes, params: ExtractRouteParams) => void
  readonly goToNewTab: (url: string) => void
  readonly goToNoParams: (url: string) => void
}

export const useNavigation = (): NavigationHooks => {
  const history = useHistory()

  const goBack = useCallback(() => {
    if (history.location.pathname === '/comments') return
    history.goBack()
  }, [])

  const goTo = useCallback((url: Routes, params: ExtractRouteParams) => {
    history.push(urlWithParams(url, params))
  }, [])

  const goToNoParams = useCallback((url: string) => {
    history.push(url)
  }, [])

  const goToNewTab = (url: string) => {
    window.open(url, '_blank');
  }

  return {
    history,
    goBack,
    goTo,
    goToNewTab,
    goToNoParams
  }
}
